import styled from '@emotion/styled';
import { DSButton } from '@hundred5/design-system';
import React from 'react';

import { InterviewSection } from '@/queries/types';

const RATING_SCALE = [1, 2, 3, 4, 5];

interface KitSectionProps {
  section: InterviewSection;
  selectedRating?: number;
  onRatingChange: (sectionTitle: string, rating: number) => void;
  disabled?: boolean;
}

export function KitRating({
  section,
  selectedRating,
  onRatingChange,
  disabled = false,
}: KitSectionProps) {
  return (
    <RatingContainer>
      {RATING_SCALE.map((value) => (
        <RatingButton
          size="xsmall"
          variant="secondary"
          key={value}
          onClick={() => onRatingChange(section.title, value)}
          selectedRating={selectedRating}
          value={value}
          disabled={disabled}
        >
          {value}
        </RatingButton>
      ))}
    </RatingContainer>
  );
}

const RatingContainer = styled.div`
  display: flex;
  gap: 4px;
`;

const RatingButton = styled(DSButton)<{
  selectedRating?: number;
  value: number;
}>`
  width: 48px;

  background: ${({ theme, selectedRating, value }) => {
    if (!selectedRating) {
      return theme.colors.white;
    }

    if (selectedRating === value) {
      switch (value) {
        case 1:
        case 2:
          return theme.colors.error[20];
        case 3:
          return theme.colors.warning[20];
        case 4:
        case 5:
          return theme.colors.success[20];
      }
    }
  }};
  border-color: ${({ theme, selectedRating, value }) => {
    if (!selectedRating) {
      return theme.colors.purple[40];
    }

    if (selectedRating === value) {
      switch (value) {
        case 1:
        case 2:
          return theme.colors.error[40];
        case 3:
          return theme.colors.warning[40];
        case 4:
        case 5:
          return theme.colors.success[40];
      }
    }
  }};
  color: ${({ theme, selectedRating, value }) => {
    if (!selectedRating) {
      return theme.typography.colorPrimary;
    }

    if (selectedRating === value) {
      switch (value) {
        case 1:
        case 2:
          return theme.colors.error[120];
        case 3:
          return theme.colors.warning[120];
        case 4:
        case 5:
          return theme.colors.success[120];
      }
    }
  }};

  &:hover {
    background: ${({ theme, selectedRating, value }) => {
      if (!selectedRating) {
        return theme.colors.purple[5];
      }

      if (selectedRating === value) {
        switch (value) {
          case 1:
          case 2:
            return theme.colors.error[30];
          case 3:
            return theme.colors.warning[30];
          case 4:
          case 5:
            return theme.colors.success[30];
        }
      }
    }} !important;
  }
`;
